export const columns = [
    {
        title:'序号',
        type:'index',
    },
    {
        title:'参与日期',
        dataIndex:"createTime",
        key:"createTime",
        width:150,
    },
    {
        title:'姓名',
        dataIndex:"donationName",
        key:"donationName",
    },
    {
        title:'上课方式',
        dataIndex:"attendClassWay",
        key:"attendClassWay",
        slots:'attendClassWay'
    },
    {
        title:'出发地',
        dataIndex:"startingPoint",
        key:"startingPoint",
    },
    {
        title:'目的地',
        dataIndex:"destination",
        key:"destination",
    },
    {
        title:'交通方式',
        dataIndex:"transport",
        key:"transport",
        slots:'transport'
    },
    {
        title:'公里数',
        dataIndex:"kilometers",
        key:"kilometers",
    },
    {
        title:'碳排系数',
        dataIndex:"carbonEmissionCoefficient",
        key:"carbonEmissionCoefficient",
    },
    {
        title:'预估碳排量',
        dataIndex:"carbonEmission",
        key:"carbonEmission",
    },
    {
        title:'实际碳排金额',
        dataIndex:"trueAmount",
        key:"trueAmount",
    },
    {
        title:'捐款金额',
        dataIndex:"donationAmount",
        key:"donationAmount",
    },
    {
        title:'参与序号',
        dataIndex:"participationNo",
        key:"participationNo",
    },
    {
        title:'是否中奖',
        dataIndex:"win",
        key:"win",
        slots:'win'
    },
    {
        title:'备注',
        dataIndex:"type",
        key:"type",
    },
]